// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-P2Q","newExpiryDate":"styles_newExpiryDate__OSghY","footer":"styles_footer__3CCTr"};